import React from "react";

import Dashboard from "../components/Dashboard";

const HomePage = () => <Dashboard />;

HomePage.propTypes = {};

export default HomePage;
